import { gql } from 'apollo-angular';

export const LIST_BANK_ACCOUNTS = gql`
  query bankAccounts($search: String) {
    bankAccounts(search: $search) {
      id
      bankName
      branchId
      branchData {
        id
      }
      accountNumber
      accountType
      currency
      openingBalance
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const LIST_CREDIT_CARDS = gql`
  query creditCards($search: String) {
    creditCards(search: $search) {
      id
      cardName
      cardNumberMasked
      issuer
      branchId
      branchData {
        id
      }
      creditLimit
      currentBalance
      currency
      expiryDate
      isActive
      createdAt
    }
  }
`;

export const GET_BANK_ACCOUNT_BY_ID = gql`
  query bankAccount($id: Int!) {
    bankAccount(id: $id) {
      id
      bankName
      branchId
      branchData {
        id
      }
      accountNumber
      accountType
      currency
      openingBalance
      isActive
    }
  }
`;

export const GET_CREDIT_CARD_BY_ID = gql`
  query creditCard($id: Int!) {
    creditCard(id: $id) {
      id
      cardName
      cardNumberMasked
      issuer
      branchId
      branchData {
        id
        branchName
      }
      creditLimit
      currentBalance
      currency
      expiryDate
      isActive
    }
  }
`;

export const FIND_UNMATCHED_STATEMENTS = gql`
  query findUnmatchedStatements(
    $bankAccountId: Float!
    $search: String
    $startDate: String
    $endDate: String
  ) {
    findUnmatchedStatements(
      bankAccountId: $bankAccountId
      search: $search
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      statementDate
      description
      amount
      bankAccountId
      # transactionStatus
      bankAccountData {
        id
        bankName
        accountNumber
        openingBalance
      }
      type
      referenceNumber
      matchedTransactionId
      matchStatus
      matchedTransactionData {
        id
        bankAccountId
        transactionType
        amount
        transactionDate
        description
        refType
        refId
        matchedStatementId
        reconciled
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FIND_BANK_TRANSACTIONS = gql`
  query bankTransactions(
    $bankAccountId: Int!
    $search: String
    $startDate: String
    $endDate: String
  ) {
    bankTransactions(
      bankAccountId: $bankAccountId
      search: $search
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      bankAccountId
      bankAccountData {
        id
        bankName
        accountNumber
        IFSCCode
        accountType
        currency
        openingBalance
        isActive
      }
      transactionType
      amount
      transactionDate
      description
      refType
      referenceNumber
      refId
      matchedStatementId
      transactionStatus
      matchedStatementData {
        id
        statementDate
        description
        amount
        bankAccountId
        type
        referenceNumber
        matchedTransactionId
        matchStatus
        createdAt
        updatedAt
        deletedAt
      }
      reconciled
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FIND_ALL_TRANSACTIONS_TOTAL = gql`
  query findAllTransactionTotals(
    $bankAccountId: Int!
    $search: String
    $startDate: String
    $endDate: String
  ) {
    findAllTransactionTotals(
      bankAccountId: $bankAccountId
      search: $search
      startDate: $startDate
      endDate: $endDate
    ) {
      netValue
      totalDebit
      totalCredit
    }
  }
`;

export const LIST_MATCHED_PAYMENT_FOR_STATEMENTS = gql`
  query listMatchedPaymentsForStatement($statementId: Int!) {
    listMatchedPaymentsForStatement(statementId: $statementId) {
      bestMatches {
        id
        bankAccountId
        transactionType
        amount
        transactionDate
        description
        refType
        refId
        referenceNumber
        matchedStatementId
        reconciled
        createdAt
        updatedAt
        deletedAt
      }
      possibleMatches {
        id
        bankAccountId
        transactionType
        amount
        transactionDate
        description
        refType
        refId
        referenceNumber
        matchedStatementId
        reconciled
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`;

export const TRANSACTION_CATEGORIES = gql`
  query transactionCategories($direction: String!) {
    transactionCategories(direction: $direction)
  }
`;

export const BANK_TRANSACTION_BY_ID = gql`
  query bankTransaction($id: Int!) {
    bankTransaction(id: $id) {
      id
      bankAccountId
      bankAccountData {
        id
        bankName
        accountType
      }
      transactionType
      amount
      transactionDate
      description
      refType
      refId
      referenceNumber
      transactionCategory
      transactionStatus
      paidVia
      matchedStatementId
      matchedStatementData {
        type
        referenceNumber
        matchedTransactionId
        matchStatus
      }
      reconciled
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
